import classNames from 'classnames';
import { orderBy } from 'lodash';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { CardBody } from 'reactstrap';

import { modelOf } from '../../../../prop-types';
import CheckoutStore from '../../../../store/CheckoutStore';
import OrderTotalClass from '../../../../types/order/OrderTotalClass';
import CheckoutSummaryBanner from '../../../ad/CheckoutSummaryBanner';
import OrderTotals from '../../../order/OrderTotals';
import CheckoutPromoCode from '../CheckoutPromoCode';
import CheckoutSubmitButton from '../CheckoutSubmitButton';
import CheckoutTerms from '../CheckoutTerms';
import CheckoutTotalWeight from '../CheckoutTotalWeight';

const CheckoutSummary = ({ checkoutStore }) => {
  const { order } = checkoutStore;
  const { cartIsEmpty, shouldUseProviderCustomerHandling } = order;

  const renderContent = () => {
    const orderedTotals = orderBy(checkoutStore.orderTotals, ['sort_order']);
    const totalIndex = orderedTotals.findIndex(
      (total) => total.class === OrderTotalClass.TOTAL
    );

    const productsTotals = orderedTotals.slice(0, totalIndex);
    const totals = orderedTotals.slice(totalIndex);
    const weight = checkoutStore.order.total_weight;
    const shouldShowTerms = checkoutStore.order.hasTerms && !shouldUseProviderCustomerHandling;
    const hasLowerContent = weight || shouldShowTerms;

    return (
      <>
        <OrderTotals totals={productsTotals} />
        <hr />
        <CheckoutPromoCode />
        <OrderTotals totals={totals} />
        {hasLowerContent && <hr />}
        {weight && <CheckoutTotalWeight />}
        <CheckoutSummaryBanner />
        {shouldShowTerms && <CheckoutTerms />}
        {!shouldUseProviderCustomerHandling && <CheckoutSubmitButton />}
      </>
    );
  };

  return (
    <CardBody
      className={classNames('CheckoutSummary', 'CheckoutSummary__body')}
    >
      {cartIsEmpty ? null : renderContent()}
    </CardBody>
  );
};

CheckoutSummary.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
};

export default inject('checkoutStore')(observer(CheckoutSummary));
